"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.METHOD = void 0;
/** Supported encryption methods */
var METHOD;
(function (METHOD) {
    METHOD["KMS"] = "kms";
    METHOD["ECIES"] = "ecies";
    METHOD["AES256_CBC"] = "aes256-cbc";
    METHOD["AES256_GCM"] = "aes256-gcm";
})(METHOD || (exports.METHOD = METHOD = {}));
//# sourceMappingURL=encryption-types.js.map